import { render, staticRenderFns } from "./PendingClaim.vue?vue&type=template&id=303dfad4"
import script from "./PendingClaim.vue?vue&type=script&lang=js"
export * from "./PendingClaim.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports